import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import type { IShipmentData, ITrackingEventDateOptions } from '@/modules/pmt/interfaces';
import { trackingEventDateModify } from '@/modules/pmt/utils';
import { DetailLeftContainer, SubTitle, Time, Title } from '../../TrackingEventCardHeader.styles';

const parcelDateFormatOptions: ITrackingEventDateOptions = {
  showDate: true,
  showTime: true,
  fullDay: false,
  showDay: true,
  isFormatTimeUnderOneDay: true,
};

export interface ITrackingEventOrderConfirmedProps {
  trackingDetails?: IShipmentData;
}

const TrackingEventOrderConfirmed = ({ trackingDetails }: ITrackingEventOrderConfirmedProps) => {
  const { t } = useGlobalState();
  const shipmentImportedDate = trackingDetails?.shipmentImportedDate ?? new Date().toISOString();

  return (
    <DetailLeftContainer>
      <Time>{trackingEventDateModify(shipmentImportedDate, parcelDateFormatOptions, t)}</Time>
      <Title>{t(MasterTranslation.OrderConfirmed)}</Title>
      <SubTitle>{t(MasterTranslation.WaitingTrackingInfo)}</SubTitle>
    </DetailLeftContainer>
  );
};

export { TrackingEventOrderConfirmed };
